module.exports = __webpack_public_path__ + "img/bg-top-section.065755e5.png";